import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/driveReport',
  component: LAYOUT,
  name: 'DriveReport',
  redirect: '/driveReport/detail',
  meta: {
    title: '试乘试驾报告详情',
  },
  children: [
    {
      path: 'detail',
      name: 'DriveReportDetail',
      meta: {
        title: '试乘试驾报告详情',
      },
      component: () => import('@/views/driveReport/detail'),
    },
  ],
};
